import axios from 'axios';

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}`,
});

const ChatBotInstance = axios.create({
  baseURL: `${process.env.CHATBOT_BASE_URL}`,
});

function getStoredAccessToken() {
  const raw = localStorage.getItem('token');
  if (!raw) return '';

  try {
    const parsed = JSON.parse(raw);
    return typeof parsed === 'string' ? parsed.trim() : '';
  } catch (e) {
    // Backward/edge case: token stored as a plain string
    return String(raw).trim();
  }
}

ChatBotInstance.interceptors.request.use(function (config) {
  if (config?.headers?.Authorization) {
    return config;
  }
  const token = getStoredAccessToken();
  let jwt = `jwt ${token}`;

  //  Have to uncomment letter for jwt token

  if (token) {
    config.headers.Authorization = jwt;
  } else {
    config.headers.Authorization = null;
  }

  return config;
});

instance.interceptors.request.use(function (config) {
  if (config?.headers?.Authorization) {
    return config;
  }
  const token = getStoredAccessToken();
  let jwt = `jwt ${token}`;

  if (token) {
    config.headers.Authorization = jwt;
  } else {
    config.headers.Authorization = null;
  }

  return config;
});
instance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error

    let errTxt = null;
    try {
      errTxt = error?.response?.data ?? JSON.parse(error?.request?.response);
    } catch (e) {
      errTxt = error?.response?.data ?? null;
    }

    const status = error?.response?.status;
    const detail = errTxt?.detail;

    // Only force logout for actual auth/session problems.
    // NOTE: HRMS APIs commonly return 403 for role-based access (e.g. Admin APIs for employees).
    // That must NOT clear the session, otherwise SSO "try admin then employee" will always log out.
    const isInvalidSession =
      status === 401 ||
      detail === 'Error decoding signature.' ||
      detail === 'Signature has expired.';

    if (isInvalidSession) {
      // Debug help for SSO issues (do not log tokens)
      try {
        // eslint-disable-next-line no-console
        console.warn('Auth error -> forcing logout', {
          url: error?.config?.url,
          method: error?.config?.method,
          status,
          detail,
        });
      } catch (e) {}

      setTimeout(function () {
        window.location.replace('/auth/login');

        localStorage.clear();
      }, 1000);
    }
    return Promise.reject(error);
  }
);
export default instance;
export { ChatBotInstance };
